import { inject } from '@angular/core';
import { NonNullableFormBuilder } from '@angular/forms';
import type { ResolveFn } from '@angular/router';
import type { PartialDeep } from 'type-fest';
import { CacheService } from '../../../../../common/services/cache.service';
import type { BaseFormResolverData } from '../../bases.routes';
import { BasesStorageKey } from '../enums/bases-storage-key';
import type { BaseForm } from '../helpers/base-form.helper';
import { BaseFormHelper } from '../helpers/base-form.helper';

export const addBaseResolver: ResolveFn<BaseFormResolverData> = () => {
  const cacheService = inject(CacheService);
  const fb = inject(NonNullableFormBuilder);

  const cacheKey = BasesStorageKey.ADD_BASE_FORM;
  const cache = cacheService.get<PartialDeep<BaseForm>>(cacheKey, {
    keepOnNavigation: true,
  });

  const form = BaseFormHelper.buildForm(fb);
  const baseForm = form.getRawValue();
  const initial: PartialDeep<BaseForm> = baseForm;

  return { form: cache ?? initial, initial };
};
